export const GET_LIST_DANHSACHTHANHLY = "GET_LIST_DANHSACHTHANHLY";
export const GET_LIST_DANHSACHTHANHLY_SUCCESS =
  "GET_LIST_DANHSACHTHANHLY_SUCCESS";
export const GET_LIST_DANHSACHTHANHLY_FAILURE =
  "GET_LIST_DANHSACHTHANHLY_FAILURE";

export const UPDATE_SEARCHTDATA_DANHSACHTHANHLY =
  "UPDATE_SEARCHTDATA_DANHSACHTHANHLY";
export const UPDATE_DANHSACHTHANHLY = "UPDATE_DANHSACHTHANHLY";
